import type { SVGProps } from 'react';
export const Inventory = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.35 6.3v1.12h11.3V6.3zm11.68 2.4c.56-.09.97-.57.97-1.12V6.14C17 5.53 16.5 5 15.84 5H4.16C3.5 5 3 5.53 3 6.14v1.44c0 .55.4 1.04.97 1.12v5.16q0 .47.34.8.33.34.83.34h9.72q.5 0 .83-.34.33-.33.34-.8zm-1.36.02H5.33v4.98h9.34zm-6.8 1.76c0-.36.3-.65.67-.65h2.92c.37 0 .68.3.68.65s-.3.66-.68.66H8.54a.67.67 0 0 1-.68-.66"
      clipRule="evenodd"
    />
  </svg>
);
